import { axiosInstance } from "./axiosConfig";
import { isAxiosError } from "axios";

interface Location {
  lat: number;
  lng: number;
}

interface Hospital {
  id: number;
  name: string;
  address: string;
  location: Location;
  phone_number: string;
}

interface HospitalsSuccessResponse {
  results: Hospital[];
  count?: number;
}

interface Pharmacy {
  id: number;
  name: string;
  address: string;
  location: Location;
  phone_number: string;
}

interface PharmaciesSuccessResponse {
  results: Pharmacy[];
  count?: number;
}


interface GenericErrorResponse {
  error?: string;
}


interface HospitalsResult {
  data: HospitalsSuccessResponse | GenericErrorResponse;
  status: number;
}

interface PharmaciesResult {
  data: PharmaciesSuccessResponse | GenericErrorResponse;
  status: number;
}

export const getHospitals = async (
): Promise<HospitalsResult> => {
  try {
    const response = await axiosInstance.get<HospitalsSuccessResponse>(
      'health/hospitals',
      {
        params: {
          is_active: true
        },
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return {
      data: response.data,
      status: response.status
    };

  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        return {
          data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
          status: error.response.status
        };
      }

      if (error.request) {
        return {
          data: { error: 'Şəbəkə xətası - cavab alınmadı' },
          status: 0
        };
      }
    }

    return {
      data: {
        error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
      },
      status: -1
    };
  }
};


export const getPharmacies = async (
): Promise<PharmaciesResult> => {
  try {
    const response = await axiosInstance.get<PharmaciesSuccessResponse>(
      'health/pharmacies',
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return {
      data: response.data,
      status: response.status
    };

  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        return {
          data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
          status: error.response.status
        };
      }

      if (error.request) {
        return {
          data: { error: 'Şəbəkə xətası - cavab alınmadı' },
          status: 0
        };
      }
    }

    return {
      data: {
        error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
      },
      status: -1
    };
  }
};

export type { Hospital, Pharmacy, Location, HospitalsSuccessResponse, PharmaciesSuccessResponse };